import type { Resource } from '@/db/types'
import { invalid } from '@/kinds/kind'
import { DATE_CATEGORIES, type DateSpec, type DateStatus } from './schema'

export type DateResource = Resource<DateSpec, DateStatus>

export const defaults = (spec: Partial<DateSpec>): DateSpec => ({
  title: '',
  date: '',
  ...spec,
  category: spec.category ?? 'other',
  repeat: spec.repeat ?? 'none',
})

export const validate = (r: DateResource): string[] => {
  const errs: string[] = []
  if (!r.spec.title.trim()) errs.push('title is required')
  if (!DATE_CATEGORIES.includes(r.spec.category)) errs.push('unknown category')
  if (!/^\d{4}-\d{2}-\d{2}$/.test(r.spec.date) || Number.isNaN(Date.parse(r.spec.date)))
    errs.push('date must be YYYY-MM-DD')
  if (r.spec.time && !/^([01]\d|2[0-3]):[0-5]\d$/.test(r.spec.time)) errs.push('time must be HH:MM')
  if (r.spec.until && r.spec.until < r.spec.date) errs.push('until must be a day on or after the date')
  if ((r.spec.minutes || r.spec.travel_minutes) && !r.spec.time)
    errs.push('a length or travel time needs a time')
  if (r.spec.lead_days !== undefined && (r.spec.lead_days < 0 || r.spec.lead_days > 90))
    errs.push('lead days run 0 to 90')
  return errs
}

export const initialStatus = (): DateStatus => ({})

export const displayName = (r: DateResource): string => r.spec.title

/** Dates have no actions: everything is a spec patch (mirrors internal/kinds/date). */
export const apply = (_r: DateResource, action: string): DateResource => {
  throw invalid(`unknown action ${action}`)
}
